import {ALLOW_ADD_SUB_APPLICATION} from 'common/types';

const initialState = {
  isAllow: false,
};

const ACTION_HANDLERS = {
  [ALLOW_ADD_SUB_APPLICATION]: (state, action) => {
    return {isAllow: action.isAllow};
  },
};

export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
